import { apiRequest } from "../util/apiUtils";

export const faqList = async (params) => {
  try {
    const res = await apiRequest("get", `faq/list`, {
      queries: params,
    });

    return res?.data;
  } catch (err) {
    throw err;
  }
};
export const faqListFont = async (params) => {
  try {
    const res = await apiRequest("get", `/faq/list-front`, {
      queries: params,
    });

    return res?.data;
  } catch (err) {
    throw err;
  }
};

export const faqAddEdit = async (payload) => {
  try {
    const res = await apiRequest(
      payload?.id ? "put" : "post",
      `faq/${payload?.id ? "edit" : "add"}`,
      {
        body: payload,
      },
      "multipart/form-data"
    );

    return res?.data;
  } catch (err) {
    throw err;
  }
};

export const faqDelete = async (payload) => {
  try {
    const res = await apiRequest("delete", `faq/delete`, {
      body: payload,
    });

    return res?.data;
  } catch (err) {
    throw err;
  }
};

export const faqStatusChange = async (payload) => {
  try {
    const res = await apiRequest("patch", `faq/status`, {
      body: payload,
    });

    return res?.data;
  } catch (err) {
    throw err;
  }
};

export const faqOrdering = async (payload) => {
  try {
    const res = await apiRequest("patch", `faq/ordering`, {
      body: payload,
    });

    return res?.data;
  } catch (err) {
    throw err;
  }
};
